var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var DripTags;
(function (DripTags) {
    //this is used to start abandoned cart
    DripTags["FunnelComplete"] = "coin-free-plus-complete";
    DripTags["FunnelStart"] = "coin-free-plus-start";
})(DripTags || (DripTags = {}));
import { UniqueUserId } from '@xylabs/pixel';
import { delay } from '@xyo-network/sdk-xyo-js';
import { AddressInfo } from '../useAddressInfo';
import { Cart } from '../useCart';
import { ContactInfo } from '../useContactInfo';
import CoinUserEventHandlerBase from './CoinUserEventHandlerBase';
import DripEvents from './Drip';
class DripEventHandler extends CoinUserEventHandlerBase {
    constructor() {
        super(...arguments);
        this.events = new DripEvents();
    }
    emailCollected() {
        throw new Error('Method not implemented.');
    }
    accountCreated() {
        throw new Error('Method not implemented.');
    }
    shareCompleted() {
        throw new Error('Method not implemented.');
    }
    buyticketsCompleted() {
        throw new Error('Method not implemented.');
    }
    installCompleted() {
        throw new Error('Method not implemented.');
    }
    funnelCompleted() {
        throw new Error('Method not implemented.');
    }
    offerRequested(_fields) {
        throw new Error('Method not implemented.');
    }
    feedbackScoreCollected(_fields) {
        throw new Error('Method not implemented.');
    }
    feedbackSourceCollected(_fields) {
        throw new Error('Method not implemented.');
    }
    goodFeedbackRequested() {
        throw new Error('Method not implemented.');
    }
    badFeedbackRequested() {
        throw new Error('Method not implemented.');
    }
    contactInfoComplete() {
        const data = this.buildIdentifyPayload(DripTags.FunnelStart);
        return this.events.identify().send(data);
    }
    addressInfoComplete() {
        const data = this.buildIdentifyPayload(DripTags.FunnelStart);
        return this.events.identify().send(data);
    }
    paymentInfoComplete() {
        const data = this.buildIdentifyPayload(DripTags.FunnelStart);
        return this.events.identify().send(data);
    }
    purchaseCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            const cart = Cart.get();
            const data = this.buildIdentifyPayload(DripTags.FunnelComplete);
            const value = cart.getValue() * 100; //drip wants it in cents
            yield this.events.identify().send(data);
            yield this.events.purchase().send({ value });
        });
    }
    buildIdentifyPayload(tag) {
        var _a;
        const cart = Cart.get();
        const contactInfo = ContactInfo.get();
        const contactInfoData = contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.getData();
        const addressInfo = AddressInfo.get();
        const coinId = new UniqueUserId().id;
        const tags = [tag];
        const email = contactInfoData.email;
        const address = addressInfo.getBillingData();
        if (!email) {
            throw Error('Missing email');
        }
        for (const item of (_a = cart.getItems()) !== null && _a !== void 0 ? _a : []) {
            tags.push(item.planId);
        }
        const payload = {
            address1: address === null || address === void 0 ? void 0 : address.address,
            address2: address === null || address === void 0 ? void 0 : address.address2,
            city: address === null || address === void 0 ? void 0 : address.city,
            country: address === null || address === void 0 ? void 0 : address.country,
            email,
            first_name: contactInfoData.firstName,
            last_name: contactInfoData.lastName,
            phone: contactInfoData.phone,
            state: address === null || address === void 0 ? void 0 : address.region,
            tags,
            user_id: coinId,
            zip: address === null || address === void 0 ? void 0 : address.postalCode,
        };
        payload.cart64 = Buffer.from(JSON.stringify(payload)).toString('base64');
        return payload;
    }
    addToCart() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    initiateCheckout() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    purchaseAttempted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    trialStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    purchaseFailed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    upsellViewed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    upsellUnavailable() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    upsellAccepted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    upsellSucceeded() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    upsellFailed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    funnelStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    testStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    userClick() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    viewContent() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
}
export default DripEventHandler;
